import { useEffect, useMemo } from 'react';
import { useQuery } from '@apollo/client/react';

import {
    IExternalContentListItemFragment,
    IExternalContentsSelectorQueryVariables,
    ExternalContentsSelectorDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export const useExternalContentList = (
    queryVariables?: IExternalContentsSelectorQueryVariables
) => {
    const { showApolloError } = useApolloError();
    const { data, loading, error } = useQuery(
        ExternalContentsSelectorDocument,
        {
            variables: queryVariables,
        }
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const externalContentsObject = data?.externalContents;
    const externalContentsCount = externalContentsObject?.count;
    const externalContents = useMemo(
        () =>
            (externalContentsObject?.edges
                .map((edge) => edge?.node || null)
                .filter(Boolean) as IExternalContentListItemFragment[]) || [],
        [externalContentsObject?.edges]
    );

    return {
        externalContents,
        externalContentsCount,
        loading,
    };
};
